import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import draggable from 'vuedraggable';
  import { useCourseBuilderStore } from '@/stores/trainings/courseBuilder';
  import TreeItem from '@/ui/components/trainings/courseBuilder/TreeItem.vue';
  import TreeToolbar from '@/ui/components/trainings/courseBuilder/TreeToolbar.vue';
  import { COURSE_TYPE } from '@/entities/trainings';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SectionsTree',
  setup(__props) {

  const { course } = useCourseBuilderStore();

  const hasAnySection = computed(() => {
    return course?.items.some(i => i.type === COURSE_TYPE.SECTION);
  });

  const hasAnyComponent = computed(() => {
    return course?.items.some(i => i.type !== COURSE_TYPE.SECTION);
  });

return { __sfc: true,course, hasAnySection, hasAnyComponent, draggable, TreeItem, TreeToolbar }
}

})